import { IApplicationState } from '../types/redux';

export function selectWithIntroScreen(state: IApplicationState) {
  return state.withIntroScreen;
}
